import React from 'react';
import { Button, message, Tooltip } from 'antd';
import { InstagramOutlined, YoutubeOutlined, UserOutlined } from '@ant-design/icons';
import { Influencer } from '../../../../services/marketingAPI';

export const EmailCell: React.FC<{ record: Influencer }> = ({ record }) => {
    const email = record.email || (record.profiles && record.profiles[0]?.email);
    if (!email) return <span style={{ color: '#ccc' }}>-</span>;
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={email}>{email}</span>
            <Button
                type="text"
                size="small"
                icon={<span style={{ fontSize: 12 }}>📋</span>}
                onClick={() => {
                    navigator.clipboard.writeText(email);
                    message.success('邮箱已复制');
                }}
                style={{ marginLeft: 4, color: '#999' }}
            />
        </div>
    );
};

export const ProfileLinkCell: React.FC<{ record: Influencer }> = ({ record }) => {
    const mainProfile = (record.profiles || []).sort((a, b) => b.follower_count - a.follower_count)[0];
    if (!mainProfile) return <span style={{ color: '#ccc' }}>-</span>;

    const renderPlatformIcon = (platform: string) => {
        const style = { fontSize: 16, marginRight: 6 };
        if (platform === 'instagram') return <InstagramOutlined style={{ ...style, color: '#E1306C' }} />;
        if (platform === 'youtube') return <YoutubeOutlined style={{ ...style, color: '#FF0000' }} />;
        if (platform === 'tiktok') return <span style={style}>🎵</span>;
        return <UserOutlined style={{ ...style, color: '#ccc' }} />;
    };

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                {renderPlatformIcon(mainProfile.platform)}
                <a href={mainProfile.url} target="_blank" rel="noopener noreferrer" style={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 140 }}>
                    {mainProfile.handle}
                </a>
            </div>
            {mainProfile.location && <div style={{ fontSize: '12px', color: '#888' }}>📍 {mainProfile.location}</div>}
        </div>
    );
};

export const BioCell: React.FC<{ record: Influencer }> = ({ record }) => {
    const mainProfile = (record.profiles || []).sort((a, b) => b.follower_count - a.follower_count)[0];
    const bio = mainProfile?.bio || record.notes;
    if (!bio) return <span style={{ color: '#ccc' }}>-</span>;

    return (
        <Tooltip title={bio} placement="topLeft" overlayStyle={{ maxWidth: '400px' }}>
            <div style={{
                fontSize: '12px',
                color: '#666',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical'
            }}>
                {bio}
            </div>
        </Tooltip>
    );
};
